/// <reference path="./window.d.ts" />
import * as lvFlandersStartschermNgUi from '../../../dist/@lvflanders/startscherm-ng-ui';

if (window.lvflanders == null) window.lvflanders = {};
if (window.lvflanders.startscherm == null) window.lvflanders.startscherm = {};
if (window.lvflanders.startscherm.ng == null) window.lvflanders.startscherm.ng = {};
window.lvflanders.startscherm.ng.ui = lvFlandersStartschermNgUi;

export { lvFlandersStartschermNgUi };
